<template>
    <div class="TTL-el-form-search-regular">
    <el-form inline="true">
        <el-form-item>
            <wcinput :option="{placeholder:'请输入日程类型名称',clearable:true,ischange:true,isinput:true,iskeydown:true}"
                :value="param.key"
                @finish="(val)=> {
                    if(val.type=='input') {param.key=val.value;param.ischange=true;}
                    if(val.type=='change') {param.key=val.value;param.ischange=true;}
                    if(val.type=='keydown') GetSheduleTypeInfos();
                }"
            />
        </el-form-item>
        <el-form-item>
            <wcbutton :option="{title:'搜索'}" @finish="GetSheduleTypeInfos" />
        </el-form-item>
        <el-form-item>
            <wcbutton :option="{title:'添加类型日程'}" @finish="AddSheduleType" />
        </el-form-item>
    </el-form>
    </div>

    <div class="TTL-table top20" id="table-schedule-obj">
        <el-table :data="list" stripe="true" empty-text="" ref="pet" @selection-change="selecttable">
            <template v-slot:empty><el-empty description="暂无数据" /></template>
            <el-table-column type="selection" />
            <el-table-column label="类型图标" align="center">
                <template #default="tscope">
                    <div class="TTL-pet-image-info">
                        <div class="TTL-pet-image">
                        <el-image :src="tscope.row.thumb ? tscope.row.thumb : require('@/assets/icon/pet-upload-default.png')" fit="cover" class="TTL-image-box-small"/>
                        </div>
                        <div class="TTL-pet-image-default">
                        <el-image :src="tscope.row.thumbdefault ? tscope.row.thumbdefault : require('@/assets/icon/pet-upload-default.png')" fit="cover"/>
                        </div>
                    </div> 
                </template>
            </el-table-column>
            <el-table-column prop="name" label="类型名称" align="center">
                <template #default="tscope">
                    <div>{{tscope.row.name}}{{tscope.row.pid==0 ? '（一级分类）' : ''}}</div>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" fixed="right" min-width="150">
                <template #default="tscope">
                    <div class="TTL-btn-list">
                    <wcbutton :option="{title:'编辑'}" @finish="EditType(tscope.row.id)" />
                    <wcbutton :option="{title:'删除',type:'del'}" @finish="DelType(tscope.row.id)" class="left10" />
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <div class="TTL-page-box top20">
        <div class="TTL-page-box-in">
            <div class="TTL-page-left">
                <wcselect :option="{placeholder:'请选择操作',clearable:true,ischange:true,width:'160px'}"
                    :value="handlevalue"
                    :list="handleinfos"
                    @finish="(val)=> {
                        if(val.type=='change') changehandle(val.value);
                    }"
                />
            </div>
            <div class="TTL-page TTL-page-right">
                <wcpage
                    :row="param.rows"
                    :p="param.p"
                    :rollpage="param.rollpage"
                    @finish="(val)=> {
                        param.p=val.p;
                        param.rollpage=val.rollpage;
                        GetSheduleTypeInfos();
                    }"
                />
            </div>
        </div>
    </div>
</template>

<script>
import INTERFACE_MODEL_PETS from '@/Interface/Pets/Schedule';
export default {
    components:{},
    data() {
        return {
            param: {
                id:'',
                key:'',
                time:'',
                ischange:false,
                p:1,
                rollpage:10,
                rows:0
            },
            handlevalue:'',
            handleinfos:[
                {id:1,name:'批量删除日程'},
                {id:2,name:'批量修改日程'},
            ],
            list:[],
        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {


        /** 修改页面显示标签信息 **/
        ChangePageLabel() {
            
        },


        /** 页数初始化 **/
        OnloadMethod() {
            this.GetSheduleTypeInfos();   //获取日程类型信息列表
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {                  //组件已存在，同级兄弟元素调用时产生的操作
                this.GetSheduleTypeInfos();   //获取宠物信息列表
            }else if(data.reload) {           //浏览器重新刷新时执行的操作
                
            }
        },


        /** 添加宠物信息 **/
        AddSheduleType() {
            var navinfo={name:'新增日程类型',labelentry:'AddScheduleType',components:'AddScheduleType',isshow:false};
            var data={Method:''};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


        /** 编辑宠物信息 **/
        EditSheduleType(ids) {
            var navinfo={name:'编辑日程类型',labelentry:'EditScheduleType',components:'EditScheduleType',isshow:false};
            var data={Method:'',ids:ids};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


        /** 批量操作 **/
        changehandle(index) {
            this.handlevalue='';
            this.$confirm.confirm(
                '该操作将会批量修改数据，且不可恢复，是否执行 ？',
                '删除提示', 
                {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}).then(()=> {

               var ids=this.GetSelectDataIds();
               if(ids.length == 0) {this.$notice({title:'消息提示',message:'请选择要批量执行的数据',type:'warning'});return false;}
               if(index==1) { //批量删除类型
                   this.DelTypeData(ids.join(',')); 

               }else if(index==2) { //批量修改类型
                   this.EditType(ids.join(','));

               }

            }).catch(()=> {
                
            });
        },


        /** 编辑宠物信息 **/
        EditType(id) {
            this.EditSheduleType(id);
        },


        /** 删除宠物 **/
        DelType(id) {
            this.DelTypeData(id);
        },


        //删除宠物信息
        DelTypeData(ids) {
            INTERFACE_MODEL_PETS.DEL_SCHEDULE_TYPE({ids:ids}).then((res) => {
                 if(res.status > 0) return false;
                 this.GetSheduleTypeInfos();
            });
        },


        ///////////////////////////////////////
        ///////////////////////////////////////
        //加载宠物信息列表

        /** 获取宠物信息列表 **/
        GetSheduleTypeInfos() {
            if(this.param.ischange) {
                this.param.p=1;
                this.param.ischange=false;
            }

            //loading等待动画加载
            var obj=document.getElementById("table-schedule-obj");
            this.$loading.openloading(obj);
            INTERFACE_MODEL_PETS.GET_SCHEDULE_TYPE_LIST(this.param).then((res) => {
                 if(res.status > 0) return false;
                 this.$loading.closeloading(obj);
                 this.param.rows=res.data.count;
                 this.list=res.data.list;
            });
        },

        /** 表格数据选择 **/
        selecttable(val) {
            for(var i=0;i < this.list.length;i++) this.list[i].isshow=false;
            for(var i=0;i < val.length;i++) val[i].isshow=true;
            console.log(this.list);
        },


        /** 获取被勾选中的列表数据 **/
        GetSelectDataIds() {
            var ids=[];
            ids=this.list.map((obj)=> obj.isshow ? obj.id : '');
            ids=ids.filter(element=> element!==null && element!==''); //数据进行去除空值处理
            return ids ? ids : [];
        },


        //加载宠物信息列表
        ///////////////////////////////////////
        ///////////////////////////////////////


    },
}
</script>
<style scoped>
.TTL-select-infos {display:inline-flex;align-items: center;}
.TTL-select-infos span {margin-left:10px;}
.TTL-pet-image-info {display:inline-block;position:relative;width:60px;height: 60px;}
.TTL-pet-image {position: relative;display: inline-block;}
.TTL-pet-image-default {width:25px;height:25px;border-radius: 50%;overflow:hidden;position: absolute;right:0;bottom:0;}

.TTL-image-box-sex {width:20px;height: 20px;position:absolute;right:0;top:0;margin-right:-5px;margin-top:-5px;border-radius: 50%;background:#ffffff;}
.TTL-pet-infos {display: flex;align-items: center;}
.TTL-pet-infos-content {display:inline-block;width:calc(100% - 80px);margin-left:20px;}
.TTL-pet-infos-content-info {display: inline-flex;align-items: center;width:100%;}
.TTL-pet-infos-content-item {display:inline-block;color:#666666;background-color: #DCDFE6;padding:7px 15px 5px 15px;font-size:12px;line-height:12px;border-radius: 20px;margin:0 10px 5px 0;zoom:.9;}
.TTL-image-box-small {border-radius: 50%;}
.TTL-btn-list {display:inline-flex;}
</style>